import classNames from "classnames"
import { ReactNode } from "react"

type WideListItemColumnProps = {
    contentIds?: string
    children: ReactNode
    growIt?: boolean
    innerClasses?: string
    outerClasses?: string
    clickHandler?: VoidFunction
    disabled?: boolean
    testId?: string
}

/**
 * provides a clickable column
 *
 * @returns
 */
export const WideListItemColumn = ({
    contentIds,
    growIt = false,
    children,
    clickHandler,
    innerClasses: innerClassesOverride,
    outerClasses: outerClassesOverride,
    disabled = false,
    testId,
}: WideListItemColumnProps) => {
    const outerClasses = classNames(
        contentIds,
        "grow bg-panel-forest-green/50 rounded-md uppercase truncate leading-[23px]",
        { "hover:bg-[#464646]": clickHandler },
        { "bg-panel-forest-green/40": disabled },
        {
            "w-1/2 grow": growIt,
            "cursor-pointer": clickHandler && !disabled,
        },
        outerClassesOverride
    )

    const innerClasses = classNames("text-center text-white", innerClassesOverride)

    return (
        <div className={outerClasses} onClick={clickHandler} data-tid={testId}>
            <div className={innerClasses}>{children}</div>
        </div>
    )
}

export default WideListItemColumn
